// web地址
const WEB_URL="https://exp.cdzyhd.com"


// const API_URL_ERP = "http://127.0.0.1:8900/"
const API_URL_ERP = "https://api.cdzyhd.com/system/erp/"
export {WEB_URL,API_URL_ERP}
